(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcd-announcement"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var wrapper = document.querySelector('#tcd-marquee-slider .marquee-wrapper');
  var content = document.querySelector('#tcd-marquee-slider .marquee-content');
  if (!wrapper || !content) return;

  var speed = parseInt("{{ section.settings.speed | default: 1 }}", 10) || 1;
  var paused = false;

  // Ensure content fully loaded
  setTimeout(function() {
    // Duplicate content for infinite scroll
    content.innerHTML = content.innerHTML + content.innerHTML;

    var translateX = 0;
    var contentWidth = content.scrollWidth / 2;

    function animate() {
      if(!paused){
        translateX -= speed;
        if(Math.abs(translateX) >= contentWidth){
          translateX = 0;
        }
        content.style.transform = 'translateX(' + translateX + 'px)';
      }
      window.requestAnimationFrame(animate);
    }
    animate();

    // Hover to pause
    wrapper.addEventListener('mouseenter', function(){ paused = true; });
    wrapper.addEventListener('mouseleave', function(){ paused = false; });

    // Item hover colors
    var items = content.querySelectorAll('.marquee-item');
    for(var i=0; i<items.length; i++){
      (function(item){
        var hoverBg = item.getAttribute('data-hover-bg');
        var hoverColor = item.getAttribute('data-hover-color');
        var originalBg = item.style.backgroundColor;
        var originalColor = item.style.color;

        item.addEventListener('mouseenter', function(){
          item.style.backgroundColor = hoverBg;
          item.style.color = hoverColor;
        });
        item.addEventListener('mouseleave', function(){
          item.style.backgroundColor = originalBg;
          item.style.color = originalColor;
        });
      })(items[i]);
    }
  }, 50); // small delay ensures correct scrollWidth
});

  } catch(e) { console.error(e); }
})();
})();
